import React from 'react';
var ThemeContext = /*#__PURE__*/React.createContext({
  system: 'light',
  branding: 'brandingAmi'
});
export default ThemeContext;
export var SystemThemeProvider = ThemeContext.Provider;
export var SystemThemeConsumer = ThemeContext.Consumer;